var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#6C59E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.616 12.136L7.472 9.592L5.408 8.208H7.936L8.84 5.48L9.76 8.208H12.272L10.208 9.592L11.08 12.136L8.84 10.512L6.616 12.136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.616 12.136L5.66821 11.8171L4.66488 14.799L7.20573 12.9436L6.616 12.136ZM7.472 9.592L8.41979 9.91091L8.6634 9.18688L8.02893 8.76144L7.472 9.592ZM5.408 8.208V7.208H2.1211L4.85107 9.03856L5.408 8.208ZM7.936 8.208V9.208H8.6581L8.88524 8.52256L7.936 8.208ZM8.84 5.48L9.78757 5.16044L8.83168 2.32603L7.89076 5.16544L8.84 5.48ZM9.76 8.208L8.81243 8.52756L9.04191 9.208H9.76V8.208ZM12.272 8.208L12.8289 9.03856L15.5589 7.208H12.272V8.208ZM10.208 9.592L9.65107 8.76144L9.01288 9.18937L9.26203 9.91625L10.208 9.592ZM11.08 12.136L10.493 12.9456L13.0501 14.7995L12.026 11.8118L11.08 12.136ZM8.84 10.512L9.42697 9.70239L8.83789 9.27531L8.25027 9.7044L8.84 10.512ZM7.56379 12.4549L8.41979 9.91091L6.52421 9.27309L5.66821 11.8171L7.56379 12.4549ZM8.02893 8.76144L5.96493 7.37744L4.85107 9.03856L6.91507 10.4226L8.02893 8.76144ZM5.408 9.208H7.936V7.208H5.408V9.208ZM8.88524 8.52256L9.78924 5.79456L7.89076 5.16544L6.98676 7.89344L8.88524 8.52256ZM7.89243 5.79956L8.81243 8.52756L10.7076 7.88844L9.78757 5.16044L7.89243 5.79956ZM9.76 9.208H12.272V7.208H9.76V9.208ZM11.7151 7.37744L9.65107 8.76144L10.7649 10.4226L12.8289 9.03856L11.7151 7.37744ZM9.26203 9.91625L10.134 12.4602L12.026 11.8118L11.154 9.26775L9.26203 9.91625ZM11.667 11.3264L9.42697 9.70239L8.25303 11.3216L10.493 12.9456L11.667 11.3264ZM8.25027 9.7044L6.02627 11.3284L7.20573 12.9436L9.42973 11.3196L8.25027 9.7044Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.48cd3e8c072b511c89ffd47b31d831be.svg";
export { ForwardRef as ReactComponent };